import React from 'react'

const SocialLinks = () => (
  <div className="blogSidebar__section">
    <h2>Follow Us Online</h2>
    <ul className="socialLinks">
      <li>
        <a
          href="https://twitter.com/cloudnexa"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa fa-twitter"></i>
        </a>
      </li>
      <li>
        <a
          href="https://www.linkedin.com/company/cloudnexa"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa fa-linkedin"></i>
        </a>
      </li>
    </ul>
  </div>
)

export default SocialLinks
